/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConsultationContentDto } from '../../models/consultation-content-dto';

export interface ConsultationContentAdminControllerDeleteV1$Params {
  id: string;
}

export function consultationContentAdminControllerDeleteV1(http: HttpClient, rootUrl: string, params: ConsultationContentAdminControllerDeleteV1$Params, context?: HttpContext): Observable<StrictHttpResponse<ConsultationContentDto>> {
  const rb = new RequestBuilder(rootUrl, consultationContentAdminControllerDeleteV1.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConsultationContentDto>;
    })
  );
}

consultationContentAdminControllerDeleteV1.PATH = '/api/v1/consultation-contents/admin/{id}';
